import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';

function InfoMisc() {
  return <>
    <Header />
    
    <div id="tiles">
        <CustomPageTiles path="/info" />
    </div>
  </>
}

export default InfoMisc;
